import * as React from "react";
import { Upload, message, Button, Modal } from "antd";
import styled from "styled-components";
import { WEBURL } from "../../constant/comman";
import { InboxOutlined } from "@ant-design/icons";

const Dragger = Upload.Dragger;

const StyledDragger = styled(Dragger)`
  & .ant-upload {
    margin-bottom: 15px;
  }

  & .ant-upload-drag {
    margin-bottom: 15px;
  }
  & .ant-upload-list-item-actions {
    display: none;
  }
`;

const props = {
  name: "file",
  action: `${WEBURL}card/upload/file`,
  // action: "http://localhost:4040/upload/file",
  headers: {
    authorization: "authorization-text",
  },
};

export class AddCardExcel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disable: true,
      jsonFile: [],
      disableUpload: true,
      temp: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.verifyDoc = this.verifyDoc.bind(this);
  }

  componentDidMount() {
    if (this.props.refx) {
      this.props.refx(this);
    }
  }

  verifyDoc() {
    var file = [];

    if (this.state.temp.length <= 0) {
      message.error("Please select a valid image");
      return;
    }
    let fileData = this.state.temp[0].response;
    this.props.onUpload({ ...fileData, name: this.state.temp[0].name });
  }

  handleChange(info) {
    var error = false;

    if (info.file.status !== "uploading") {
      if (info.fileList.length < 1) {
        this.setState({
          disable: true,
        });
      } else {
        this.setState({
          disable: false,
        });
      }
    }

    if (info.file.status === "done") {
      if (info.file.response.code === "ERROR_IN_UPLOAD") {
        message.error(info.file.response.msg);
        error = true;
      } else {
        message.success(`${info.file.name} file uploaded successfully.`);

        this.setState(
          {
            temp: info.fileList,
          },
          () => {
            this.verifyDoc();
          }
        );
        error = false;
      }
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
      error = true;
    }
  }

  handleCancel = (e) => {
    this.hide();
  };

  show() {
    this.setState({
      visible: true,
    });
  }

  hide() {
    this.setState(
      {
        visible: false,
        temp: [],
      }
      // temp.length > 0 ? this.props.onUpload(temp) : this.props.onUpload(null)
    );
  }

  render() {
    return (
      <Modal
        width="600px"
        closable={this.state.closable}
        open={this.state.visible}
        onCancel={this.handleCancel}
        footer={null}
      >
        <div style={{ marginTop: "20px", paddingBottom: "30px" }}>
          <StyledDragger
            accept=".xls,.xlsx"
            className="clearfix"
            {...props}
            onChange={this.handleChange}
            onRemove={(file) => console.log("Removed -- ", file)}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p className="ant-upload-hint" style={{ marginBottom: "10px" }}>
              Support for a single or bulk upload. Strictly prohibit from
              uploading company data or other band files
            </p>
          </StyledDragger>
        </div>
      </Modal>
    );
  }
}
